import apiClient from '../client'

export const companyAdminService = {
  signup: async (payload) => {
    const response = await apiClient.post('/companyAdmins/signup', payload)
    return response.data
  },

  list: async (params = {}) => {
    const response = await apiClient.get('/companyAdmins', { params })
    return response.data
  },

  getById: async (adminId) => {
    const response = await apiClient.get(`/companyAdmins/${adminId}`)
    return response.data
  },

  create: async (payload) => {
    const response = await apiClient.post('/companyAdmins', payload)
    return response.data
  },

  update: async (adminId, payload) => {
    const response = await apiClient.patch(`/companyAdmins/${adminId}`, payload)
    return response.data
  },

  delete: async (adminId) => {
    const response = await apiClient.delete(`/companyAdmins/${adminId}`)
    return response.data
  },
}
